import type DistinguishedFolderIdName from "owa-service/lib/contract/DistinguishedFolderIdName";

/**
 * Distinguished folder types that must reject all drag-drop drops. Dropping mail items
 * or folders into these folders is never a valid operation, so their canDrop handlers
 * should always return 'none'.
 */
const dragDropDisabledFolderTypes: DistinguishedFolderIdName[] = ["notes", "scheduled", "outbox"];

/**
 * Returns true when the given distinguished folder type cannot be a drag-drop target.
 * Shared by the folder-tree and favorites canDrop handlers so both stay in sync.
 * @param distinguishedFolderType the target folder's distinguished folder type
 */
export function isDragDropDisabledFolderType(distinguishedFolderType: DistinguishedFolderIdName | null | undefined): boolean {
    return (distinguishedFolderType != null &&
        dragDropDisabledFolderTypes.indexOf(distinguishedFolderType) !== -1);
}
